import { borderRadius, Icon, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { CardType } from '../../StreamCard';

export const IconWrapper = styled.div<{
  $type: CardType;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${borderRadius.rFull};
  padding: 2px;
  width: 16px;
  height: 16px;
  background-color: ${({ $type }) => {
    switch ($type) {
      case CardType.CompanyCatalyst:
        return 'var(--surface-decorative-lime-default)';
      case CardType.MarketCatalyst:
        return 'var(--surface-decorative-cyan-default)';
      case CardType.MarketSummary:
        return 'var(--surface-decorative-gold-default)';
      case CardType.Scenario:
        return 'var(--surface-decorative-indigo-default)';
      case CardType.EarningsPreview:
        return 'var(--surface-decorative-purple-default)';
      case CardType.EarningsRecap:
        return 'var(--surface-decorative-teal-default)';
      default:
        return 'var(--surface-default)';
    }
  }};
`;

export const TitleLabel = styled.div<{
  $type?: CardType;
}>`
  ${typographyV2.uiXs};
  color: ${({ $type }) => {
    switch ($type) {
      case CardType.MarketCatalyst:
        return 'var(--text-decorative-cyan)';
      case CardType.MarketSummary:
        return 'var(--text-decorative-gold)';
      case CardType.Scenario:
        return 'var(--text-decorative-indigo)';
      case CardType.EarningsPreview:
        return 'var(--text-decorative-purple)';
      case CardType.EarningsRecap:
        return 'var(--text-decorative-teal)';
      default:
        return $type === CardType.CompanyCatalyst
          ? 'var(--text-decorative-lime)'
          : 'var(--text-decorative-cyan)';
    }
  }};
  white-space: nowrap;
`;

export const StyledPillWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

export const StyledScenarioIcon = styled(Icon)`
  > path {
    fill: var(--icon-decorative-indigo);
  }
`;
